import type { FC } from 'react';
import { BaseIcon } from '@/Module/Icon/Component/BaseIcon';
import type { IIconProps } from '@/Module/Icon/Model';
export const IconSend: FC<IIconProps> = props => {
  return <BaseIcon {...props} data-sentry-element="BaseIcon" data-sentry-component="IconSend" data-sentry-source-file="IconSend.tsx">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="IconSend.tsx">
        <g clipPath="url(#clip0_8719_22722)" data-sentry-element="g" data-sentry-source-file="IconSend.tsx">
          <path d="M2.82276 12.0008H18.9976" stroke="#C2C3C4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="IconSend.tsx" />
          <path d="M2.82298 11.9996L22.6739 21.1919L18.9978 11.9996L22.6739 2.80717L2.82298 11.9996Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="IconSend.tsx" />
        </g>
        <defs data-sentry-element="defs" data-sentry-source-file="IconSend.tsx">
          <clipPath id="clip0_8719_22722" data-sentry-element="clipPath" data-sentry-source-file="IconSend.tsx">
            <rect width="24.9541" height="24" fill="white" transform="matrix(-1 0 0 1 24.9531 0)" data-sentry-element="rect" data-sentry-source-file="IconSend.tsx" />
          </clipPath>
        </defs>
      </svg>
    </BaseIcon>;
};